import { Component, OnInit, ViewChild } from '@angular/core';
import { DataSharingService } from '../../AuthGuard/DataSharingService';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
declare var $: any;
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import { LosService } from 'src/app/_LOS/services/los.service';
import { MasterService } from '../../Shared/app.Masters.Service';
import { LmsService } from '../../_Lms/services/lms.service';

@Component({
  selector: 'app-quickloan-inquiry-list',
  templateUrl: './quickloan-inquiry-list.component.html',
  styleUrls: ['./quickloan-inquiry-list.component.scss']
})
export class QuickLoanInquiryListComponent implements OnInit {
  currentUser: any;
  selectedRowIndex: number = -1;
  InquiryList: any[] = [];
  showSpinner: boolean = false;
  status: any = 'Pending';
  dataSource: any;
  displayedColumns: string[] = [];

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  assignModel: any = {};
  loading: boolean = false;
  BranchesList: any[] = [];
  employeeDropdown: any[] = [];
  rejectModel: any = {};
  ProductList: any[] = [];

  SelectSourceType: any = '';
  SelectBranch: any[] = [];
  SourceTypeList: any[] = [];
  partnerDropdown: any[] = [];
  LeadSourceName: any = 0;
  SalesExecutiveData: any[] = [];

  configSuccess: MatSnackBarConfig = {
    panelClass: 'style-success',
    duration: 5000,
    horizontalPosition: 'right',
    verticalPosition: 'top'
  };

  branchSettings = {
    singleSelection: false,
    idField: 'BranchId',
    textField: 'Branch_Name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: true,
    itemsShowLimit: 1,
    showSelectedItemsAtTop: true,
    searchPlaceholderText: 'Search Branch'
  };

  constructor(
    private MasterService: MasterService,
    private dataSharingService: DataSharingService,
    private snackBar: MatSnackBar,
    private router: Router,
    private losService: LosService,
    private lmsService: LmsService
  ) {}

  ngOnInit() {
    this.dataSharingService.LOSHeaderTitle.next('Inquiry List');
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.getBranchesList();
    this.getLeadSourceDropdown();
    this.GetSalesExecutive();
    this.getInquiryList();
  }

  highlight(row: any) {
    this.selectedRowIndex = row.InquiryId;
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getTotalLoanAmount(): number {
    const data = Array.isArray(this.dataSource)
      ? this.dataSource
      : this.dataSource?.data || [];
    return data.reduce((acc: number, row: any) => acc + (Number(row.LoanAmount) || 0), 0);
  }

  onStatusChange() {
    this.getInquiryList();
  }

  // Reset and rebuild source-name options whenever source type changes.
  onSourceTypeSelectionChange() {
    this.Get_PartnerForDropdown();
  }

  onBranchSelectionChange() {
    this.BranchesList = this.moveSelectedItemsToTop(
      this.BranchesList,
      this.SelectBranch,
      'BranchId'
    );
  }

  onSearchInquiryList() {
    this.getInquiryList();
  }

  getSelectedFilterValue(items: any[], key: string): string {
    const selectedIds = items?.map((item: any) => item[key]).filter(Boolean) || [];
    return selectedIds.length ? selectedIds.join(',') : '0';
  }

  getSourceNameValue(): string {
    return this.LeadSourceName && this.LeadSourceName !== 0 ? String(this.LeadSourceName) : '0';
  }

  isSourceNameFilterVisible(): boolean {
    return !!this.SelectSourceType;
  }

  moveSelectedItemsToTop(items: any[], selectedItems: any[], key: string): any[] {
    if (!items?.length) {
      return [];
    }

    const selectedIds = new Set(
      (selectedItems || []).map((item: any) => String(item[key]))
    );

    const selected = items.filter((item: any) => selectedIds.has(String(item[key])));
    const unselected = items.filter((item: any) => !selectedIds.has(String(item[key])));

    return [...selected, ...unselected];
  }

  getInquiryList() {
    this.showSpinner = true;

    if (this.status == 'Assigned') {
      this.displayedColumns = ['InquiryId', 'InquiryNo', 'CustomerName', 'CustomerAddress', 'ContactNumber', 'LoanAmount', 'Purpose', 'SourceType', 'SourceName', 'TAT', 'CreateOn', 'Branch', 'SaleExcutive'];
    } else if (this.status == 'Rejected') {
      this.displayedColumns = ['InquiryId', 'InquiryNo', 'CustomerName', 'CustomerAddress', 'ContactNumber', 'LoanAmount', 'Purpose', 'SourceType', 'SourceName', 'TAT', 'CreateOn', 'RejectedBy', 'RejectionReason'];
    } else if (this.status == 'Pending') {
      this.displayedColumns = ['InquiryId', 'InquiryNo', 'CustomerName', 'CustomerAddress', 'ContactNumber', 'LoanAmount', 'Purpose', 'SourceType', 'SourceName', 'TAT', 'Status', 'Remarks', 'CreateOn', 'CreatedBy', 'Assign', 'Reject'];
    } else {
      this.displayedColumns = ['InquiryId', 'InquiryNo', 'CustomerName', 'CustomerAddress', 'ContactNumber', 'LoanAmount', 'Purpose', 'SourceType', 'SourceName', 'TAT', 'CreateOn', 'CreatedBy'];
    }

    this.losService.GetLosInquiryList({
      InqStatus: this.status,
      LoginUserId: this.currentUser.userId,
      BranchId: this.getSelectedFilterValue(this.SelectBranch, 'BranchId'),
      SourceType: this.SelectSourceType || '0',
      SourceName: this.getSourceNameValue(),
      SourceId: this.getSourceNameValue()
    }).subscribe((res: any) => {
      this.InquiryList = JSON.parse(JSON.stringify(res));
      this.dataSource = new MatTableDataSource(this.InquiryList);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.showSpinner = false;

      setTimeout(() => {
        $('[data-toggle="tooltip"]').tooltip();
      }, 1000);
    });
  }

  OnOpenAssignModal(data: any, e: any) {
    if (e) {
      e.stopPropagation();
    }
    this.assignModel = {};
    this.assignModel.InquiryId = data.InquiryId;
    this.assignModel.LoginUserId = this.currentUser.userId;
    this.assignModel.InquiryNo = data.InquiryNo;
    this.assignModel.BranchId = '';
    this.assignModel.Product_Id = '';
    this.assignModel.AssignedTo = '';
    this.getProductDropdown();
    $('#assignToInquiry').modal('show');
    $('#assignToInquiry').css('z-index', '1050');
  }

  OnClose() {
    $('#assignToInquiry').modal('hide');
  }

  onOpenRejectModal(data: any, e: any) {
    e.stopPropagation();
    this.rejectModel.InquiryId = data.InquiryId;
    this.rejectModel.LoginUserId = this.currentUser.userId;
    this.rejectModel.Reason = '';
    $('#rejectInquiry').modal('show');
    $('#rejectInquiry').css('z-index', '1050');
  }

  OnCloseReject() {
    this.rejectModel = {};
    $('#rejectInquiry').modal('hide');
  }

  getBranchesList() {
    this.lmsService.GetBranches({
      Emp_Id: this.currentUser.userId
    }).subscribe((result: any) => {
      this.BranchesList = JSON.parse(JSON.stringify(result));
    });
  }

  getLeadSourceDropdown() {
    this.losService.getLeadSourceDropdown({}).subscribe((result: any) => {
      this.SourceTypeList = JSON.parse(JSON.stringify(result));
    });
  }

  GetSalesExecutive() {
    this.losService.getEmployeeDropdown({
      BranchId: 0,
      ProcessId: 1,
      ProductId: 0
    }).subscribe((res: any) => {
      this.SalesExecutiveData = JSON.parse(JSON.stringify(res));
    });
  }

  Get_PartnerForDropdown() {
    this.partnerDropdown = [];
    this.LeadSourceName = 0;

    if (
      this.SelectSourceType == 'Agent' ||
      this.SelectSourceType == 'DSA' ||
      this.SelectSourceType == 'Dealer'
    ) {
      this.losService.Get_PartnerForDropdown({
        PartnerType: this.SelectSourceType,
        branchId: 0
      }).subscribe((res: any) => {
        this.partnerDropdown = JSON.parse(JSON.stringify(res || []));
      });
      return;
    }

    if (
      this.SelectSourceType == 'Sales Executive' ||
      this.SelectSourceType == 'Telecaller Executive' ||
      this.SelectSourceType == 'Marketing Executive'
    ) {
      this.partnerDropdown = (this.SalesExecutiveData || []).map((obj: any) => ({
        PartnerId: obj.EmpId,
        Partner_Name: obj.EmpName
      }));
    }
  }

  getUpdateBranch() {
    this.assignModel.Product_Id = '';
    this.assignModel.AssignedTo = '';
    this.employeeDropdown = [];
  }

  getEmployeeDropdown() {
    this.assignModel.AssignedTo = '';
    this.employeeDropdown = [];
    if (this.assignModel.BranchId) {
      this.losService.getEmployeeDropdown({
        BranchId: this.assignModel.BranchId,
        ProcessId: 1,
        ProductId: this.assignModel.Product_Id
      }).subscribe((res: any) => {
        this.employeeDropdown = res;
      });
    }
  }

  onSaveAssignment() {
    this.loading = true;
    this.OnClose();
    this.losService.assignToInquiry(this.assignModel).subscribe((res: any) => {
      this.loading = false;

      if (res[0].CODE == 0) {
        this.snackBar.openFromComponent(SnackbarComponent, { data: res[0].MSG, ...this.configSuccess });
        this.losService.LOS_EmployeeMobileDeviceID({ EmployeeID: this.assignModel.AssignedTo }).subscribe((deviceRes: any) => {
          this.getInquiryList();
          for (let i = 0; i < deviceRes.length; i++) {
            this.assignModel.deviceID = deviceRes[i].FCM_Token;
            this.assignModel.Notificationmessage = 'New Leads has been assigned to you';
            this.assignModel.type = '1';
            this.losService.sendFCMnotification(this.assignModel).subscribe(() => {
              this.getInquiryList();
            });
          }
        });
      } else {
        this.snackBar.openFromComponent(SnackbarComponent, { data: res[0].MSG, ...this.configSuccess });
      }
    });
  }

  onRejectInquiry() {
    this.loading = true;
    this.losService.rejectInquiry(this.rejectModel).subscribe((res: any) => {
      this.loading = false;
      if (res[0].CODE == 0) {
        this.snackBar.openFromComponent(SnackbarComponent, { data: res[0].MSG, ...this.configSuccess });
        this.getInquiryList();
        this.OnCloseReject();
      } else {
        this.snackBar.openFromComponent(SnackbarComponent, { data: res[0].MSG, ...this.configSuccess });
      }
    });
  }

  exportTable(): void {
    const uri = 'data:application/vnd.ms-excel;base64,';
    const template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string => window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string => s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById('quickloan_inquiry_list') as HTMLTableElement;
    const worksheetName = 'QUICK LOAN INQUIRY LIST';
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement('a');
    downloadLink.href = uri + base64(format(template, ctx));
    downloadLink.download = worksheetName + '.xls';
    downloadLink.click();
  }

  getProductDropdown() {
    this.MasterService.GetProductList({ Emp_Id: this.currentUser.userId }).subscribe((result: any) => {
      this.ProductList = JSON.parse(JSON.stringify(result));
    });
  }
}
